import Axios from 'axios'

const alert = {
  getTermsOfUse () {
    return Axios.get(`/api/v1/terms-of-use`)
  },
  getPrivacyPolicy () {
    return Axios.get(`/api/v1/privacy-policy`)
  }
}

export default alert
